import { getEnv } from 'configs/env';
import {
  Button,
  CreateAlert,
  InputWraper,
  NumberUtils,
  onError,
  Table,
  useForm,
} from 'modules';
import moment from 'moment';
import React, { FC, useState } from 'react';
import * as XLSX from 'xlsx';
import * as Yup from 'yup';

import { InputNumber } from '../../../components';
import { PopupWraper } from '../../../components/popup';
import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../../components/table-filter-inputs';
import { AdminService } from '../../../services/admin';
import { useSelector } from '../../../store';
import { withFranchiseWraper } from '../wraper';

export const PageFranchiseTable = withFranchiseWraper(() => {
  const user = useSelector((state) => state.user);
  const [currentData, setCurrentData] = useState(null as any);
  const [currentUserSetLevel, setCurrentUserSetLevel] = useState<any>();
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false);
  const [isShowTable, setIsShowTable] = useState<boolean>(true);
  const [params, setParams] = useState<any>();

  const startOfMonth = moment().subtract(1, 'months').startOf('month');
  const endOfDay = moment().endOf('day');

  return (
    <div className='PageFranchiseTable'>
      <Button
        disabled={!currentData}
        label='Export to Excel'
        buttonType='success'
        className='mb15'
        onClick={async () => {
          const response = await AdminService.getListAffilateTable({
            ...params,
            pageSize: 10000,
            page: 1,
          });
          const data = [
            [
              'User',
              'Total Volume',
              'Profit',
              // "Withdraw",
              'USDT Balance',
              'Commission USDT Balance',
              'Current Volume Downlines',
              'Past Week Volume Downlines',
              'Rank Commission',
              // "Direct Commission",
              'Cashback',
              'Exchange In',
              'Exchange Out',
              'Level',
              // "Agency Count",
            ],
            ...response.data.map((item: any) => {
              const ParseIP = item?.ip ? `IP: ${item?.ip}` : `IP: ?`;
              const row: any[] = [];
              row.push(item?.firstName + '\n' + item?.email + '\n' + ParseIP);
              row.push(
                item?.volume
                  ? NumberUtils.toFormatNumber(
                      +item?.volume,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.profitVolume
                  ? NumberUtils.toFormatNumber(
                      +item?.profitVolume,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              // row.push(`USDT: ${item?.withdrawUsdt ? NumberUtils.toFormatNumber(+item?.withdrawUsdt, 4) : `0.00000000`}`);
              row.push(
                item?.balanceGp2
                  ? NumberUtils.toFormatNumber(
                      +item?.balanceGp2,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.balanceUsdt
                  ? NumberUtils.toFormatNumber(
                      +item?.balanceUsdt,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.volumeAllBranch
                  ? NumberUtils.toFormatNumber(
                      +item?.volumeAllBranch,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.volumeAllBranchByDay
                  ? NumberUtils.toFormatNumber(
                      +item?.volumeAllBranchByDay,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.rankCommission
                  ? NumberUtils.toFormatNumber(
                      +item?.rankCommission,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.cashBack
                  ? NumberUtils.toFormatNumber(
                      +item?.cashBack,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.exchangeIn
                  ? NumberUtils.toFormatNumber(
                      +item?.exchangeIn,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(
                item?.exchangeOut
                  ? NumberUtils.toFormatNumber(
                      +item?.exchangeOut,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : `0.00000000`,
              );
              row.push(item?.rank);

              return row;
            }),
          ];

          const ws = XLSX.utils.aoa_to_sheet(data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

          const now = new Date();
          XLSX.writeFile(
            wb,
            `Franchise ${now.toLocaleDateString().replace(/\//g, '-')} ${now
              .toLocaleTimeString()
              .replace(/:/g, '-')}.xlsx`,
            { type: 'binary' },
          );
        }}
      />

      {isShowTable && (
        <Table
          hasOrderColumn
          className='overload'
          filters={[
            {
              name: 'Email',
              key: 'searchString',
              input: TableFilterInputText,
            },
            {
              name: 'Date',
              key: 'created',
              input: (e) => (
                <TableFilterRangeTimeInput
                  {...e}
                  fromKey='fromDate'
                  toKey='toDate'
                  format={'MM/dd/y'}
                />
              ),
              // defaultValue: {
              //     //fromDate: moment().subtract(1,"months"),
              //     //toDate: moment(),
              //     fromDate: startOfMonth,
              //     toDate: endOfDay,
              // },
            },
          ]}
          structure={[
            {
              name: 'User',
              key: 'q',
              render: (item) => {
                return (
                  <div className='user'>
                    <span
                      className='user-clickable'
                      onClick={() => {
                        setCurrentUserSetLevel(item);
                        setIsShowPopup(true);
                      }}
                    >
                      {item.firstName} <br />
                      {item.email} <br />
                    </span>
                    <span className='ip'>IP: {item?.ip ?? '?'}</span>
                  </div>
                );
              },
            },
            {
              name: 'Total Volume',
              key: 'volume',
              render: (item) => {
                const value = +item.volume;
                return value
                  ? NumberUtils.toFormatNumber(
                      +item.volume,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : '0.00000000';
              },
              sort: {},
            },
            {
              name: 'Profit',
              key: 'profitVolume',
              render: (item) => {
                const value = +item.profitVolume;
                return value ? (
                  <span
                    className={
                      item?.profitVolume === 0
                        ? ''
                        : item?.profitVolume > 0
                          ? 'profit-volume-green'
                          : 'profit-volume-red'
                    }
                  >
                    {NumberUtils.toFormatNumber(
                      +item?.profitVolume,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )}
                  </span>
                ) : (
                  <span className='profit-volume-green'>0.00000000</span>
                );
              },
              sort: {},
            },
            // {
            //     name: "Won volume",
            //     key: "wonVolume",
            //     className: "textSuccess",
            //     render: (item) => {
            //         return `$${(+item.wonVolume).toLocaleString(
            //             getLocaleKey(),
            //             {
            //                 maximumFractionDigits: 2,
            //                 minimumFractionDigits: 2,
            //             }
            //         )}`;
            //     },
            //     sort: {},
            // },
            // {
            //     name: "Lose volume",
            //     key: "lostVolume",
            //     className: "textDanger",
            //     render: (item) => {
            //         const value = +item.lostVolume;
            //         return value
            //             ? `$${(+item.lostVolume).toLocaleString(
            //                   getLocaleKey(),
            //                   {
            //                       maximumFractionDigits: 2,
            //                       minimumFractionDigits: 2,
            //                   }
            //               )}`
            //             : "$0.00";
            //     },
            //     sort: {},
            // },
            // {
            //     name: "Draw volume",
            //     key: "drawVolume",
            //     className: "textWarning",
            //     render: (item) => {
            //         const value = +item.drawVolume;
            //         return value
            //             ? `$${(+item.drawVolume).toLocaleString(
            //                   getLocaleKey(),
            //                   {
            //                       maximumFractionDigits: 2,
            //                       minimumFractionDigits: 2,
            //                   }
            //               )}`
            //             : "$0.00";
            //     },
            //     sort: {},
            // },
            // {
            //   name: "Deposit",
            //   render: (item) => {
            //     return (
            //       <span>
            //         ETH:{" "}
            //         {(+item.depositEth).toLocaleString(getLocaleKey(), {
            //           maximumFractionDigits: 8,
            //           minimumFractionDigits: 8
            //         })}{" "}
            //         <br />
            //         USDT:{" "}
            //         {(+item.depositUsdt).toLocaleString(getLocaleKey(), {
            //           maximumFractionDigits: 8,
            //           minimumFractionDigits: 8
            //         })}
            //       </span>
            //     );
            //   },
            // },
            // {
            //     name: "Withdraw",
            //     render: (item) => {
            //         return (
            //             <span>
            //                 USDT:{" "}
            //                 {NumberUtils.toFormatNumber(+item?.withdrawUsdt, 4)}
            //             </span>
            //         );
            //     },
            // },
            // {
            //   name: "Balance",
            //   render: (item) => {
            //     return (
            //       <span>
            //         USDT:{" "}
            //         {NumberUtils.toFormatNumber(
            //           +item?.balanceGp2,
            //           +getEnv("NUMBER_DECIMAL_DISPLAY")
            //         )}{" "}
            //         <br />
            //         COMMISSION USDT:{" "}
            //         {NumberUtils.toFormatNumber(
            //           +item?.balanceUsdt,
            //           +getEnv("NUMBER_DECIMAL_DISPLAY")
            //         )}
            //       </span>
            //     );
            //   },
            // },
            {
              name: 'USDT Balance',
              key: 'balanceGp2',
              render: (item) => {
                return (
                  <span>
                    {NumberUtils.toFormatNumber(
                      +item?.balanceGp2,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )}
                  </span>
                );
              },
              sort: {},
            },
            {
              name: 'Commission USDT Balance',
              key: 'balanceUsdt',
              render: (item) => {
                return (
                  <span>
                    {NumberUtils.toFormatNumber(
                      +item?.balanceUsdt,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )}
                  </span>
                );
              },
              sort: {},
            },
            {
              name: 'Current Volume Downlines',
              key: 'volumeAllBranch',
              render: (item) => {
                const value = +item.volumeAllBranch;
                return value
                  ? NumberUtils.toFormatNumber(
                      +item.volumeAllBranch,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : '0.00000000';
              },
              sort: {},
            },
            {
              name: 'Past Week Volume Downlines',
              key: 'volumeAllBranchByDay',
              render: (item) => {
                const value = +item.volumeAllBranchByDay;
                return value
                  ? NumberUtils.toFormatNumber(
                      +item.volumeAllBranchByDay,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : '0.00000000';
              },
              sort: {},
            },
            {
              name: 'Rank Commission',
              key: 'rankCommission',
              render: (item) => {
                return NumberUtils.toFormatNumber(
                  +item?.rankCommission,
                  +getEnv('NUMBER_DECIMAL_DISPLAY'),
                );
              },
              sort: {},
            },
            // {
            //   name: "Direct Commission",
            //   key: "directCommission",
            //   render: (item) => {
            //     return `${(+item.directCommission).toLocaleString(
            //       getLocaleKey(),
            //       { maximumFractionDigits: 2, minimumFractionDigits: 2 }
            //     )}`;
            //   },
            //   sort: {},
            // },
            {
              name: 'Cashback 0.2%',
              key: 'cashBack',
              render: (item) => {
                return NumberUtils.toFormatNumber(
                  +item?.cashBack,
                  +getEnv('NUMBER_DECIMAL_DISPLAY'),
                );
              },
            },
            {
              name: 'Exchange In',
              key: 'exchangeIn',
              render: (item) => {
                const value = +item.exchangeIn;
                return value
                  ? NumberUtils.toFormatNumber(
                      +item?.exchangeIn,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : '0.00000000';
              },
            },
            {
              name: 'Exchange Out',
              key: 'exchangeOut',
              render: (item) => {
                const value = +item.exchangeOut;
                return value
                  ? NumberUtils.toFormatNumber(
                      +item?.exchangeOut,
                      +getEnv('NUMBER_DECIMAL_DISPLAY'),
                    )
                  : '0.00000000';
              },
            },
            {
              name: 'Level',
              render: (item) => (
                <img
                  className='level'
                  src={`/assets/images/rank/rank_${item?.rank}.png`}
                  alt=''
                />
              ),
            },
            // {
            //   name: "Agency Count",
            //   key: "agencyCount",
            //   render: (item) => {
            //     return `${(+item.agencyCount).toLocaleString(getLocaleKey(), {
            //       maximumFractionDigits: 2,
            //       minimumFractionDigits: 2
            //     })}`;
            //   },
            //   sort: {},
            // },
          ]}
          fetchData={async (state) => {
            // AdminService.getFranchiseUserReport(100, user.userId, params).then(
            //   (res) => {
            //     setCurrentData(res);
            //     return res;
            //   }
            // )
            const params = { ...state };
            setParams(params);
            if (params['fromDate'])
              params['fromDate'] = new Date(params['fromDate']);
            if (params['toDate']) params['toDate'] = new Date(params['toDate']);
            return AdminService.getListAffilateTable({
              ...params,
              pageSize: params.limit,
              page: params.pageNumber,
            }).then((res) => {
              setCurrentData(res);
              return res;
            });
          }}
        />
      )}
      {isShowPopup && (
        <SetLevelPopup
          dataUser={currentUserSetLevel}
          onClose={(value: any) => setIsShowPopup(value)}
          onIsShowTable={(value: any) => setIsShowTable(value)}
        />
      )}
    </div>
  );
});

const SetLevelPopup: FC<any> = (props) => {
  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure: [
      {
        name: 'level',
        validate: Yup.number()
          .required('Must be provided')
          .integer('Number must be integer')
          .max(8, 'Maximum is 8')
          .min(1, 'Minimum is 1'),
      },
    ],
    onSubmit: async (values) => {
      props?.onIsShowTable(false);
      return AdminService.setLevel(props?.dataUser?.userId, values.level)
        .then(() => {
          return CreateAlert({
            type: 'success',
            message: 'Set level successfully.',
          });
        })
        .catch(onError)
        .finally(() => {
          props?.onIsShowTable(true);
          props?.onClose(false);
        });
    },
  });

  return (
    <PopupWraper title='Set level' onClose={() => props?.onClose(false)}>
      <div style={{ fontSize: '16px' }} className='container'>
        <fieldset style={{ marginBottom: '32px' }}>
          <legend>Information:</legend>
          <div className='display-name'>
            Display name:{' '}
            <span style={{ color: '#fff' }}>{props?.dataUser?.firstName}</span>
          </div>
          <div className='email'>
            Email:{' '}
            <span style={{ color: '#fff' }}>{props?.dataUser?.email}</span>
          </div>
          <div className='level'>
            Current level:{' '}
            <span style={{ color: '#fff' }}>{props?.dataUser?.rank}</span>
          </div>
        </fieldset>
        <InputWraper
          inputProps={getInputProps('level')}
          renderInput={InputNumber}
        />
        <Button
          onClick={handleSubmit}
          isLoading={isSubmitting}
          label='Set level'
          buttonType='success'
          type='submit'
        />
      </div>
    </PopupWraper>
  );
};

// export const SystemReportDetailPopup: FC<{
//     detail: any;
//     onClose: () => void;
// }> = (props) => {
//     if (!props.detail) return null;

//     const item = props.detail;

//     const data = [
//         {
//             label: "Start",
//             value: `${new Date(item.start).toLocaleDateString(getLocaleKey(), {
//                 hour12: false,
//             })} - ${new Date(item.start).toLocaleTimeString(getLocaleKey(), {
//                 hour12: false,
//             })}`,
//         },
//         {
//             label: "End",
//             value: `${new Date(item.end).toLocaleDateString(getLocaleKey(), {
//                 hour12: false,
//             })} - ${new Date(item.start).toLocaleTimeString(getLocaleKey(), {
//                 hour12: false,
//             })}`,
//         },
//         {
//             label: "Modified",
//             value: `${new Date(item.modified).toLocaleDateString(
//                 getLocaleKey(),
//                 {
//                     hour12: false,
//                 }
//             )} - ${new Date(item.start).toLocaleTimeString(getLocaleKey(), {
//                 hour12: false,
//             })}`,
//         },
//         {
//             label: "Total won/lose volume",
//             value: `${(+item.wonVolume).toLocaleString(getLocaleKey(), {
//                 maximumFractionDigits: 2,
//                 minimumFractionDigits: 2,
//             })}/${(+item.lostVolume).toLocaleString(getLocaleKey(), {
//                 maximumFractionDigits: 2,
//                 minimumFractionDigits: 2,
//             })}`,
//         },
//         {
//             label: "Hot Wallet",
//             value: (
//                 <span>
//                     USD:{" "}
//                     {(+item.hotWalletUsd).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 2,
//                         minimumFractionDigits: 2,
//                     })}{" "}
//                     <br />
//                     USDT:{" "}
//                     {(+item.hotWalletUsdt).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 8,
//                         minimumFractionDigits: 8,
//                     })}
//                 </span>
//             ),
//         },
//         {
//             label: "Deposit",
//             value: (
//                 <span>
//                     USD:{" "}
//                     {(+item.depositUsd).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 2,
//                         minimumFractionDigits: 2,
//                     })}{" "}
//                     <br />
//                     USDT:{" "}
//                     {(+item.depositUsdt).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 8,
//                         minimumFractionDigits: 8,
//                     })}
//                 </span>
//             ),
//         },
//         {
//             label: "Withdraw",
//             value: (
//                 <span>
//                     USD:{" "}
//                     {(+item.withdrawUsd).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 2,
//                         minimumFractionDigits: 2,
//                     })}{" "}
//                     <br />
//                     USDT:{" "}
//                     {(+item.withdrawUsdt).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 8,
//                         minimumFractionDigits: 8,
//                     })}
//                 </span>
//             ),
//         },
//         {
//             label: "User 's Balance",
//             value: (
//                 <span>
//                     USD:{" "}
//                     {(+item.userBalanceUsd).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 2,
//                         minimumFractionDigits: 2,
//                     })}{" "}
//                     <br />
//                     USDT:{" "}
//                     {(+item.userBalanceUsdt).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 8,
//                         minimumFractionDigits: 8,
//                     })}
//                 </span>
//             ),
//         },
//         {
//             label: "Safe",
//             value: (
//                 <span>
//                     USD:{" "}
//                     {(+item.safeUsd).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 2,
//                         minimumFractionDigits: 2,
//                     })}{" "}
//                     <br />
//                     USDT:{" "}
//                     {(+item.safeUsdt).toLocaleString(getLocaleKey(), {
//                         maximumFractionDigits: 8,
//                         minimumFractionDigits: 8,
//                     })}
//                 </span>
//             ),
//         },
//         {
//             label: "Login Count",
//             value: item.loginCount,
//         },
//         {
//             label: "Direct Commission",
//             value: item.directCommission,
//         },
//         {
//             label: "CashBack",
//             value: (+item.cashBack).toLocaleString(getLocaleKey(), {
//                 maximumFractionDigits: 2,
//                 minimumFractionDigits: 2,
//             }),
//         },
//         {
//             label: "New Package",
//             value: item.newPackage,
//         },
//         {
//             label: "Trading Commission",
//             value: item.rankCommission,
//         },
//     ];

//     return (
//         <div
//             className="SystemReport__DetailPopup"
//             id="SystemReport__DetailPopup"
//             onClick={(e: any) =>
//                 e.target.id === "SystemReport__DetailPopup"
//                     ? props.onClose()
//                     : null
//             }
//         >
//             <div className="box">
//                 <div className="boxTitle">
//                     <span>Detail Report</span>
//                     <div className="btnClose" onClick={() => props.onClose()}>
//                         <Icon.Close />
//                     </div>
//                 </div>
//                 <div className="content overload">
//                     <table>
//                         <tbody>
//                             {data.map((row, key) => (
//                                 <tr key={key}>
//                                     <td>{row.label}</td>
//                                     <td>{row.value}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
